import { Spinner } from "react-bootstrap";

export default function AfterButton({ handleNext, lockNextBtn }) {
	return (
		<button className="btn btn-primary float-right" onClick={handleNext} disabled={lockNextBtn}>
			{lockNextBtn && <Spinner style={{ width: "4rem", height: "4rem" }} className="spinner-loading" animation="border" size="" />}
			Siguiente <i className="fa-solid fa-chevron-right"></i>
		</button>
	);
}
